import styled from "styled-components";
import {GameJackpotValueDefaultBox} from "./game-jackpot-value.default.box";

export const GameJackpotValueMrGreenBox = styled(GameJackpotValueDefaultBox)`
    width: 100%;
    background: ${props => props.theme.colors.brandPrimaryDark};
    box-shadow: 0px 0px 0px rgba(1, 85, 54, 0.6), inset 0px 0px 20px rgba(255, 255, 255, 0.1), inset 0px 0px 10px ${props => props.theme.colors.brandSecondary};
    color: ${props => props.theme.colors.moneyColor};
`;